import type { DocumentationType } from '../..'
import { Usecase } from '..'

export class DocumentationUsecase extends Usecase {
    createURL (doc: DocumentationType): URL {
        return this.configurationService.getDocumentationURL(doc)
    }
}
